import type { taskEither } from "fp-ts";

import type {
  ChangeStatus,
  Common,
  Create,
  Delete,
  Get,
  GetMany,
  GetPaginated,
  SpecifyPayment,
  Update,
  UpdateServices,
} from "./ios";

import type { AuthenticationError, NotFoundError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract create(params: Create.In): taskEither.TaskEither<UnexpectedError, Common.Out>;
  abstract update(
    params: Update.In,
  ): taskEither.TaskEither<
    UnexpectedError | AuthenticationError | NotFoundError | Common.UpdateError,
    Common.Out
  >;
  abstract updateServices(
    params: UpdateServices.In,
  ): taskEither.TaskEither<
    UnexpectedError | AuthenticationError | NotFoundError | Common.UpdateError,
    UpdateServices.Out
  >;
  abstract delete(params: Delete.In): taskEither.TaskEither<UnexpectedError | NotFoundError, void>;
  abstract specifyPayment(
    params: SpecifyPayment.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract get(params: Get.In): taskEither.TaskEither<UnexpectedError | NotFoundError, Common.Out>;
  abstract getMany(
    params: Common.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetMany.Out>;
  abstract changeStatus(
    params: ChangeStatus.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, void>;
  abstract getPaginated(
    params: GetPaginated.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetPaginated.Out>;
}

export { Provider };
